import { templateStore } from '../template/index.js';
import { NOTIFICATION_CONFIG, NOTIFICATION_TYPES } from './store.js';

/**
 * Render notification list into a container
 */
export function displayNotification(container, notifications = [], filter = 'all', currentUserRole = 'end-user-client') {
	if (!container) return;

	const template = templateStore.get('notifications/item.ejs');
	const emptyTemplate = templateStore.get('notifications/empty.ejs');

	if (!notifications.length) {
		// eslint-disable-next-line no-undef
		container.innerHTML = ejs.render(emptyTemplate, { filter }) || '';
		return;
	}

	let html = '';
	notifications.forEach(notification => {
		// eslint-disable-next-line no-undef
		html += ejs.render(template, {
			notification,
			notificationConfig: NOTIFICATION_CONFIG,
			NOTIFICATION_TYPES: NOTIFICATION_TYPES,
			currentUserRole: currentUserRole
		});
	});

	container.innerHTML = html;
}

/**
 * Update tab indicators
 *
 * @param {Object} indicators
 * @param {NotificationStore} store
 */
export function updateTabCounts(indicators, store) {
	if (indicators.all) {
		indicators.all.textContent = `(${store.getCount('all')})`;
	}
	if (indicators.unread) {
		indicators.unread.textContent = `(${store.getCount('unread')})`;
	}
}

/**
 * Render loading state
 */
export function renderLoading() {
	return `<div class="flex items-center flex-col text-sm text-gray-900 gap-2 font-medium justify-center p-6 w-full h-full min-h-[100px]">
		<div class="w-8 h-8 border-3 border-primary-100 border-t-primary-500 rounded-full animate-spin"></div>
		${wpcore.direct_t({ en: 'Loading', fr: 'Chargement' })}
	</div>`;
}

/**
 * Toggle See All button visibility based on notification count
 */
export function toggleSeeAllButton(count) {
	const seeAllBtn = document.getElementById('see-all-notifications-btn');
	if (!seeAllBtn) return;

	if (count > 3) {
		seeAllBtn.classList.remove('hidden');
	} else {
		seeAllBtn.classList.add('hidden');
	}
}

